const KEY = "theta-paper-cart";

export const PAPER_SET_DISCOUNT_PERCENT = 10;
export const PAPER_SET_DISCOUNT_MIN_QUANTITY = 3;

export function getPaperLinePricing(prices = [], quantity = 0) {
  const selectedPrices = prices.slice(0, quantity);
  const subtotal = selectedPrices.reduce((sum, price) => sum + price, 0);
  const discount = selectedPrices.length >= PAPER_SET_DISCOUNT_MIN_QUANTITY
    ? Math.floor((subtotal * PAPER_SET_DISCOUNT_PERCENT + 50) / 100)
    : 0;
  return { subtotal, discount, total: subtotal - discount };
}

export function getPaperCart() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (!Array.isArray(value)) return [];
    const quantities = new Map();
    value.forEach((item) => {
      // Migrate carts saved by the previous string-only format.
      const paperId = typeof item === "string" ? item : item?.paper_id;
      const quantity = typeof item === "string" ? 1 : Number(item?.quantity);
      if (typeof paperId === "string" && Number.isInteger(quantity) && quantity > 0) {
        quantities.set(paperId, Math.min(50, (quantities.get(paperId) || 0) + quantity));
      }
    });
    return [...quantities].map(([paper_id, quantity]) => ({ paper_id, quantity }));
  } catch {
    return [];
  }
}

export function setPaperCart(items) {
  const clean = [];
  const seen = new Set();
  let totalQuantity = 0;
  items.forEach((item) => {
    const paper_id = typeof item === "string" ? item : item?.paper_id;
    const quantity = typeof item === "string" ? 1 : Number(item?.quantity);
    if (typeof paper_id === "string" && !seen.has(paper_id) && Number.isInteger(quantity) && quantity > 0 && totalQuantity < 50) {
      const acceptedQuantity = Math.min(quantity, 50 - totalQuantity);
      seen.add(paper_id);
      clean.push({ paper_id, quantity: acceptedQuantity });
      totalQuantity += acceptedQuantity;
    }
  });
  localStorage.setItem(KEY, JSON.stringify(clean));
  window.dispatchEvent(new CustomEvent("paper-cart-updated", { detail: clean }));
  return clean;
}

export function togglePaperInCart(id) {
  const current = getPaperCart();
  const selected = current.some((item) => item.paper_id === id);
  return setPaperCart(selected ? current.filter((item) => item.paper_id !== id) : [...current, { paper_id: id, quantity: 1 }]);
}

export function updatePaperQuantity(id, quantity) {
  const current = getPaperCart();
  if (quantity <= 0) return setPaperCart(current.filter((item) => item.paper_id !== id));
  return setPaperCart(current.map((item) => item.paper_id === id ? { ...item, quantity } : item));
}

export function clearPaperCart() {
  return setPaperCart([]);
}
